// ./src/contexts/CategoriesContext/CategoriesContext.tsx
import React, { createContext, useContext } from "react";
import {
  UseCategoriesReturn,
  UseCategoriesOptions,
  useCategories,
} from "@/hooks";

export interface CategoriesContextValue extends UseCategoriesReturn {
  // Additional context-specific methods if needed in the future
}

export interface CategoriesProviderProps {
  children: React.ReactNode;
  options?: UseCategoriesOptions;
}

const CategoriesContext = createContext<CategoriesContextValue | undefined>(
  undefined
);

export const CategoriesProvider: React.FC<CategoriesProviderProps> = ({
  children,
  options = {},
}) => {
  const categoriesHook = useCategories(options);

  return (
    <CategoriesContext.Provider value={categoriesHook}>
      {children}
    </CategoriesContext.Provider>
  );
};

// Custom hook for using the categories context
export const useCategoriesContext = (): CategoriesContextValue => {
  const context = useContext(CategoriesContext);
  if (context === undefined) {
    throw new Error(
      "useCategoriesContext must be used within a CategoriesProvider"
    );
  }
  return context;
};
